import { Box } from "@mui/material";

import { ProgramCard } from "../../../../GoService/components/ProgramCard";

import { ProgramPost } from "../../../types/post.type";

const ProgramPostCard = ({ post: { service } }: { post: ProgramPost }) => {
  return (
    <Box sx={{ padding: "0 16px" }}>
      <ProgramCard service={service} width="100%" />
    </Box>
  );
};

export default ProgramPostCard;
